module.exports = __webpack_public_path__ + "img/logo.a751da94.png";